/* Define your initial state here.
 *
 * If you change the type from object to something else, do not forget to update
 * src/container/App.js accordingly.
 */
import * as types from "../actions/action-types";

const initialState = {
  detail: [],
  history: [],
  fetchingDetail: false,
  fetchingProfile: false,
  fetchingNotes: false,
  showNotesSidePanel: false,
  showProfileSidePanel: false,
  CurrentLeases: [],
  CurrentDriver:{},
  notes: [],
  NotesCount: 0,
  dashboardType: ""
};

const reducer = (state = initialState, action = {}) => {
  /* Keep the reducer clean - do not mutate the original state. */
  // const nextState = Object.assign({}, state);

  switch (action.type) {
    /**
     * fetch vehicle/driver profile
     */
    /*************************Fetch Profile action states START ***************************/
    case `${types.DASHBOARD_PROFILE}_PENDING`: {
      return Object.assign({}, state, {
        fetchingProfile: true,
        history: [],
        CurrentLeases:[],
        CurrentDriver:{}
      });
    }
    case `${types.DASHBOARD_PROFILE}_FULFILLED`: {
      return Object.assign({}, state, {
        fetchingProfile: false,
        ...action.payload.data
      });
    }
    case `${types.DASHBOARD_PROFILE}_REJECTED`: {
      return {
        isRejected: true,
        error: "Get Profile Failed"
      };
    }
    /*************************Fetch Profile action states END ***************************/

    /**
     * graph detail
     */
    /*************************Fetch graph detail action states START ***************************/
    case `${types.FETCH_REPORT_DETAILS}_PENDING`:
      return Object.assign({}, state, {
        detail: [],
        fetchingDetail: true,
        prevState: {}
      });

    case `${types.FETCH_REPORT_DETAILS}_FULFILLED`:
      return Object.assign({}, state, {
        detail: action.payload.data || action.payload.data.Data,
        fetchingDetail: false,
        serverError: false
      });

    case `${types.FETCH_REPORT_DETAILS}_REJECTED`:
      return {
        isRejected: true,
        error: "Fetch Report detail action Failed"
      };
    /*************************Fetch graph detail action states END ***************************/
    /**
     * graph detail
     */
    /*************************Fetch graph detail action states START ***************************/
    case `${types.FETCH_CARD_DETAILS}_PENDING`:
      return Object.assign({}, state, {
        detail: [],
        fetchingDetail: true,
        prevState: {}
      });

    case `${types.FETCH_CARD_DETAILS}_FULFILLED`:
      return Object.assign({}, state, {
        detail: action.payload.data || action.payload.data.Data,
        // reportDetail: reportDetail,
        fetchingDetail: false,
        serverError: false
      });

    case `${types.FETCH_CARD_DETAILS}_REJECTED`:
      return {
        isRejected: true,
        error: "Fetch Report detail action Failed"
      };
    /*************************Fetch graph detail action states END ***************************/

    /**
     * fetch vehicle/driver NOTES
     */
    /*************************Fetch vehicle/driver NOTES action states START ***************************/
    case `${types.PROFILE_NOTES}_PENDING`: {
      return Object.assign({}, state, {
        fetchingNotes: true
      });
    }
    case `${types.PROFILE_NOTES}_FULFILLED`: {
      return Object.assign({}, state, {
        fetchingNotes: false,
        notes: action.payload.data.Details
      });
    }
    case `${types.PROFILE_NOTES}_REJECTED`: {
      return {
        isRejected: true,
        error: "Get Driver Notes Failed"
      };
    }

    case `${types.ADD_NOTES}`: {
      let notes = state.notes.slice();
      let NotesCount = state.NotesCount;

      notes.unshift({
        Note: action.meta.notes,
        DaysToolText: "today",
        UserFirstName: action.meta.UserFirstName,
        UserSurname: action.meta.UserSurname
      });
      NotesCount++;
      return Object.assign({}, state, {
        notes,
        NotesCount
      });
    }
    /*************************Fetch vehicle/driver NOTES action states START END ***************************/
    /**
     * vehicle history
     */
    /*************************Fetch vehicle history action states START ***************************/
    case `${types.FETCH_VEHICLE_HISTORY}_PENDING`:
      return Object.assign({}, state, {
        history: [],
        fetchingDetail: true,
        prevState: {}
      });

    case `${types.FETCH_VEHICLE_HISTORY}_FULFILLED`:
      return Object.assign({}, state, {
        history: action.payload.data || action.payload.data.Data,
        // reportDetail: reportDetail,
        fetchingDetail: false,
        serverError: false
      });

    case `${types.FETCH_VEHICLE_HISTORY}_REJECTED`:
      return {
        isRejected: true,
        error: "Fetch vehicle history action Failed"
      };
    /*************************Fetch vehicle history action states END ***************************/

    case `${types.SET_VEHICLE_HISTORY}`:
      return Object.assign({}, state, {
        detail: action.data,
        fetchingDetail: false,
        serverError: false
      });

    case `${types.SET_BOOKMARK}`:
      return Object.assign({}, state, {
        Bookmarked: action.meta.bookmarked
      });

    case `${types.SET_SIDE_PANEL}`:
      return Object.assign({}, state, {
        showNotesSidePanel: action.data.showNotesSidePanel,
        showProfileSidePanel: action.data.showProfileSidePanel
      });

    default: {
      /* Return original state if no actions were consumed. */
      return state;
    }
  }
};

export default reducer;



// WEBPACK FOOTER //
// ./src/features/dashboard/reducer/index.js